import loadable from '@loadable/component';

export const Body = loadable(() => import('./body/body'));
export const Footer = loadable(() => import('./Footer/Footer'));
export const Header = loadable(() => import('./Header/Header'));
